<template>
  <div class="gameplan">
    <!-- PR维护 -->
    <ContentHeader />
    <div class="content">
      <div class="main">
        <div class="search">
          <el-form
            :inline="true"
            :model="queryParams"
            ref="searchForm"
            class="searchForm"
          >
            <el-form-item class="item" prop="prNumber">
              <el-input
                v-model="queryParams.prNumber"
                placeholder="PR编码"
                size="small"
                clearable
              />
            </el-form-item>
            <el-form-item class="item" prop="prName">
              <el-input
                v-model="queryParams.prName"
                placeholder="PR名称"
                size="small"
                clearable
              />
            </el-form-item>
            <el-form-item class="item-btn">
              <el-button type="danger" size="small" @click="queryPrList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="small" @click="resetForm()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="normal_title">PR列表</div>
        <div class="card_box" v-loading="listLoading">
          <div v-if="prList.length > 0">
            <el-card
              class="item-list"
              v-for="item in prList"
              :key="item.prId"
            >
              <div class="item_list_top">
                <div class="top_title_box">
                  <div class="top_left">PR编码：{{ item.prNumber }}</div>
                  <div class="top_center">PR名称：{{ item.prName }}</div>
                </div>
                <div class="right_btn_box">
                  <div class="right_btn" @click="handleUpdatePr(item.prNumber)" v-if="(!item.isShow && item.prStatus !== 6 && item.prStatus !== 13 && item.rejectStatus!==1)">
                    退回PR
                  </div>
                  <div v-if="item.prStatus == 6 || item.prStatus == 13" class="right_btn" @click="handleCanclePR(item.prNumber)">
                    关闭PR
                  </div>
                </div>
              </div>
              <div class="item_list_bottom">
                <div class="bottom_left">
                  <div class="first">
                    <!-- <img
                      class="img"
                      src="../../assets/images/active-img.png"
                      alt=""
                    /> -->
                    <div class="text">主品牌名称：{{ item.brandName }}</div>
                  </div>
                  <div class="second">PR状态：{{ getPrStatusText(item.prStatus) }}</div>
                </div>
                <div class="center">
                  <div class="center-first">
                    子品牌名称：{{ item.subBrandName }}
                  </div>
                  <div>配置状态：{{ getRejectStatusText(item.rejectStatus, item.isShow) }}</div>
                </div>
                <div class="center" >
                  <div class="center-first" v-if="item.empName" >
                    品牌审批人：{{ item.empName }}
                  </div>
                  <div class="center-first" v-else > &ensp; </div>
                  <div v-if="item.rejectReason">
                    <el-tooltip v-if="item.rejectReason.length>14" class="item" effect="dark" :content="item.rejectReason" placement="top">
                      <div class="text-overflow-hidden" v-if="item.rejectReason">拒绝理由：{{ item.rejectReason }}</div>
                    </el-tooltip>
                    <div  class="text-overflow-hidden" v-else>拒绝理由：{{ item.rejectReason }}</div>
                  </div>
                </div>
                <div class="right">
                  <div class="right-btn" @click="goPo(item.prNumber)">
                    查看PO信息
                  </div>
                </div>
              </div>
            </el-card>

            <div class="content-pagination">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :page-sizes="[10, 20, 30, 40]"
                :current-page="queryParams.page"
                :page-size="queryParams.pageSize"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              />
            </div>
          </div>
          <div v-else class="no_data">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "@/api/gameplan";
export default {
  name: "PR-maintain",
  components: {
    ContentHeader,
  },
  data() {
    return {
      queryParams: {
        prNumber: '',
        prName: '',
        page: 1,
        pageSize: 10,
      },
      total: 0,

      params: {
        prNumber: "",
        prName: "",
        prStatus: "3",
        brandCode: "",
        brandName: "",
        subBrandCode: "",
        subBrandName: "",
      },
      dialogVisible: false,
      prList: [],

      listLoading: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getGameplanPRList();
  },
  watch: {},
  methods: {
    resetForm() {
      this.queryParams.page = 1
      this.queryParams.prNumber = ''
      this.queryParams.prName = ''
      this.getGameplanPRList()
    },
    queryPrList (page) {
      this.queryParams.page = page
      this.getGameplanPRList()
    },
    async getGameplanPRList() {
      this.listLoading = true
      const { data } = await gameplanApi.getGameplanPRList(this.queryParams);
      this.listLoading = false;
      if (data.resultCode === "0") {
        this.prList = data.resultData?.prList || [];
        this.total = data.resultData.pageInfo.totalCounts;
      }
    },
    handleCanclePR(prNumber) {
      this.$confirm("是否要关闭PR?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        type: "warning",
      })
        .then(async () => {
          const { data } = await gameplanApi.getGameplanPrimeCancelPR(
            prNumber
          );
          if (data.resultCode === "0") {
            this.$message.success("PR关闭成功！");
            this.getGameplanPRList();
            this.resetForm();
          } else {
            this.$message.error(data.resultMsg);
          }
        })
        .catch(() => {});
    },
    async handleUpdatePr(prNumber){
      this.$confirm('是否要申请退回PR，不关联活动配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          let params = {
            prNumber,
            processAction:'01'
          }
          const { data } = await gameplanApi.getGameplanPRPOUpdatePr(params);
          if (data.resultCode === "0") {
            this.$message.success("申请退回成功！");
            this.getGameplanPRList()
            this.resetForm()
          } else {
            this.$message.error(data.resultMsg);
          }
        }).catch(() => {
        });
    },

    getPrStatusText(prStatus) {
      if (prStatus === 3) {
        return '有效'
      } else if (prStatus === 6 || prStatus === 13) {
        return 'VP退回'
      } else if (prStatus === 7) {
        return '已关闭'
      } else {
        return ''
      }
    },

    getRejectStatusText(rejectStatus, isShow) {
      if (isShow) {
        return '已配置'
      } else {
        if (rejectStatus === 0) {
          return '可配置'
        } else if (rejectStatus === 1) {
          return '申请退回'
        } else if (rejectStatus === 2) {
          return '已退回'
        }
      }
    },

    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getGameplanPRList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getGameplanPRList();
    },
    goPo(prNumber) {
      this.$router.push({
        path: "/gameplan/activity/PO-maintain",
        query: { prNumber },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-card {
  border: 0;
}

.header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}

.content {
  width: 100%;
  line-height: 20px;
  background-color: #f3f5f9;
  text-align: center;
  font-family: SourceHanSansSC-regular;
  margin-top: 30px;

  .main {
    width: 894px;
    min-height: calc(100vh - 400px);
    margin: 0 auto;
    margin-bottom: 80px;
    .search {
      text-align: left;
      // margin-left: 60px;
      .searchForm {
        width: 100%;
        .item {
          width: 200px;
        }
        .item-btn {
          margin-left: 30px;
        }
      }
    }
    .normal_title {
      margin-top: 10px;
    }
    .box-card {
      width: 894px;
      line-height: 20px;
      border-radius: 8px;
      font-size: 14px;

      .form-box {
        display: flex;
        flex-wrap: wrap;
        padding-left: 10px;
        margin-top: 20px;

        .item-lable {
          // border: 1px solid ;
          margin-right: 20px;
          margin-top: 5px;
          height: 30px;

          .item {
            width: 170px;
            height: 30px;
            border-radius: 4px;
            text-align: left;
          }
        }

        .btn {
          width: 100%;
          margin: 20px 0 30px 0;
          // margin: 60px 0 20px 70px;
        }
      }
    }

    .card_box {
      min-height: 200px;
    }

    .item-list {
      width: 100%;
      //height: 130px;
      border-radius: 8px;
      text-align: center;
      margin-bottom: 25px;

      .item_list_top {
        width: 100%;
        //height: 58px;
        background-color: #ffd6e8;
        display: flex;
        justify-content: space-between;
        padding: 13px 0;

        .top_title_box {
          display: flex;
          //align-items: center;
          //width:calc(100% - 175px);
          word-break: break-all;
          line-height:29px;

          .top_left {
            // width: 172px;
            font-weight: 600;
            color: #cd1231;
            font-size: 18px;
            text-align: left;
            margin: 0 20px 0 20px;
            min-width: 250px;
          }

          .top_center {
            // width: 174px;
            text-align:left;
            font-size: 13px;
            font-weight: bold;
            margin-right: 10px;
          }
        }
        .right_btn_box {
          text-align: right;
          //min-width: 160px;
          display:flex;
          justify-content:flex-end;
          flex-wrap: nowrap;
          word-break: keep-all;
        }

        .right_btn {
          display: inline-block;
          min-width: 30px;
          padding: 3px 12px;
          font-size: 12px;
          height: 21px;
          border-radius: 4px;
          text-align: center;
          background-color: #ffffff;
          border: 1px solid #2185d0;
          color: #2185d0;
          margin-right: 20px;
          cursor: pointer;
        }

        .right_link {
          color: #2185d0;
          padding: 5px 20px 5px 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .item_list_bottom {
        width:calc( 100% - 200px);
        position: relative;
        //height: 72px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
        line-height: 25px !important;
        padding-bottom: 8px;

        .bottom_left {
          min-width: 150px;

          .first {
            display: flex;
            margin-bottom: 4px;
            margin-top: 10px;

            .img {
              height: 15px;
              margin-top: 5px;
              width: 15px;
              margin-right: 3px;
            }

            .text {
              font-size: 13px;
              text-align: left;
            }
          }

          .second {
            height: 20px;
            font-size: 13px;
            text-align: left;
            margin-top: -5px;
          }
        }

        .center {
          margin-left: 58px;
          font-size: 13px;
          text-align: left;
          color: #101010;
          min-width: 230px;

          .center-first {
            margin-top: 10px;
          }
        }

        .right {
          // padding:3px 12px;
          // font-size: 12px;
          // border-radius: 4px;
          // text-align: center;
          // background-color: #ffffff;
          //border: 1px solid #2185d0;
          color: #2185d0;
          //margin-right: 20px;
          position: absolute;
          left: 780px;
          flex: 0.88;
          line-height: 68px;
          font-size: 12px;
          text-align: right;
          .right-btn {
            cursor: pointer;
            width: 80px;
          }
        }
      }
    }
  }
}

.no_data {
  background-color: #fff;
  color: grey;
  width: 100%;
  min-height: 120px;
  line-height: 120px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
}

.form_style {
  margin: 10px 20px;
}

.edit_dialog {
  .el-select {
    width: 100%;
  }
}
.text-overflow-hidden{
  cursor: pointer;
  height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
